import React, { useEffect, useState } from "react";
import Chart from 'react-apexcharts';

export const PiechartPreview = (props) => {
    const [chartData, setChartData] = useState({
        series: [],
        options: {
            chart: {
                type: props.type,
            },
            labels: [],
        },
    });

    const [dimensions, setDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        const handleResize = () => {
            setDimensions({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setChartData(formatProps(props));
    }, [props]);

    const formatProps = (props) => {
        return {
            series: props.values.split(',').map(item => {
                const num = parseFloat(item.trim());
                return isNaN(num) ? 0 : parseFloat(num.toFixed(2));
            }),
            options: {
                legend: {
                    show: props.showLegend === "Y",
                    position: props?.legendPosition ?? '',
                    horizontalAlign: 'center',
                    floating: false,
                    fontSize: '14px',
                    fontFamily: props.fontFamily,
                    fontWeight: 400,
                },
                tooltip: {
                    enabled: false,
                },
                colors: (props?.seriesColor ?? "").split(",").map(color => {
                    // Agregamos # solo si no lo tiene
                    return color.startsWith("#") ? color : `#${color}`;
                }),
                chart: {
                    background: (props?.colorBackground ?? '').startsWith("#") ? (props?.colorBackground ?? '') : `#${(props?.colorBackground ?? '')}`,
                    fontFamily: props.fontFamily,
                    foreColor: '#373d3f',
                    type: props.type,
                    width: '100%',
                    height: '100%',
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: '100%'
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }],
                labels: props.labels.split(',').map(item => item.trim()),
            }
        };
    };

    // No renderizar hasta que tengamos datos válidos
    if (!chartData.series.length || !chartData.options.labels.length) {
        return (
            <div style={{ width: "100%", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: (props?.colorBackground ?? '').startsWith("#") ? (props?.colorBackground ?? '') : `#${(props?.colorBackground ?? '')}` }}>
                <div>Cargando...</div>
            </div>
        );
    }

    return (
        <div style={{ width: "100vw", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: (props?.colorBackground ?? '').startsWith("#") ? (props?.colorBackground ?? '') : `#${(props?.colorBackground ?? '')}` }}>
            <Chart
                options={chartData.options}
                series={chartData.series}
                type={props.type}
                width={dimensions.width * 0.9}
                height={dimensions.height * 0.9}
            />
        </div>
    );
};
